import { useLingui } from '@lingui/react/macro';
import { User } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import SoccerPitchIcon from 'ud-ui/components/icon/soccer-pitch-icon';
import TeamsIcon from 'ud-ui/components/icon/teams-icon';
import MenuItem from '../menu-item';
import * as S from './styles';

interface UDMenuCategoriesProps {
  className?: string;
}

const UDMenuCategories = React.memo((props: UDMenuCategoriesProps) => {
  const { t } = useLingui();

  return (
    <S.MenuMainNavigation className={props.className}>
      <div className={'flex flex-col'}>
        <MenuItem to={Pages.TEAMS.INDEX} icon={<TeamsIcon />} label={t`Команды`} />

        <MenuItem to={Pages.PLAYERS.INDEX} icon={<User size={16} />} label={t`Игроки`} />

        <MenuItem to={Pages.LOCATIONS.INDEX} icon={<SoccerPitchIcon />} label={t`Локации`} />
      </div>
    </S.MenuMainNavigation>
  );
});

export default UDMenuCategories;
